const state = {
    darkMode: false,
    toaster: {
        show: false,
        type: 'info',
        message: '',
        time: 5000
    },
    buttons: {
        index: 'Inicio',
        projects: 'Proyectos',
        myProjects: 'Ver mis proyectos',
        contact: 'Contacto',
        contactMe: 'Contáctame'
    },
    navbar: {
        title:'<NixCoded />',
        show:{
            profile:false,
            mobileMenu:false
        },
        items: [
            {
                name:'Inicio', 
                key:'index', 
                icon:'circle-notch',
                path:'/'
            },
            {
                name: 'Experiencia',
                key: 'experience',
                icon: 'layer-group',
                path: '/experience' 
            },
            {
                name:'Proyectos', 
                key:'projects', 
                icon:'project-diagram',
                path:'/projects'
            }
        ],
        darkMode: 'Modo Dark',
        contact:{
            title: ' Contacto',
            items: [
                {name:'+58 424 2181154', path:'https://wa.me/+584242181154'},
                {name:'dev@nixcoded.com', path:'https://mail.google.com/mail/?view=cm&source=mailto&to=dev@nixcoded.com'},
                {name:'Perfil de Linkedin', path:'https://www.linkedin.com/in/nixoncd/'}
            ]
        }
    },
    footer: {
        leftText: 'Vue.js | Tailwind',
        rightText: 'Nixon Cedeño'
    },
    index: {
        pictures: {
            photo: "/images/nixcoded-logo-min.png"
        },
        info: {
            name: "Nixon D. Cedeño F.",
            degree: "Lic. Computación",
            profession: "Desarrollador Web Full Stack",
            direction: "Caracas, Venezuela",
        },        
    },
    projects: {
        title: 'Mis Proyectos',
        items: [
            {
                title: "THM", 
                url: '/thm',
                description: "Sitio web de presentación de la empresa",
                subtitle:'Maquinarias',
                year:'2021',
                logo: '/images/logos/thm-logo.png',
                width: 180,
                height: 60,
                titleColor: 'red',
                colorGrade: 600,
                colorGradeDark: 300,
                tools: ['Nuxt.js', 'Vuetify', 'Django REST Framework', 'PostgreSQL']
            },            
            {
                title: "EMIN", 
                url: '/emin',
                description: "Sitio web de presentación de la empresa",
                subtitle:'Ingeniería y Construcción',
                year:'2021',
                logo: '/images/logos/emin-logo-min.png',
                width: 180,
                height: 90,
                titleColor: 'blue',
                colorGrade: 900,
                colorGradeDark: 400,
                tools: ['Nuxt.js', 'Vuetify', 'Django REST Framework', 'PostgreSQL']
            },            
            {
                title: "Allegador", 
                url: '/allegador',
                description: "App online de un inventario, carga de productos, venta y compra",
                subtitle:'Inventario Online',
                year:'2021',
                logo: 'https://avatars.dicebear.com/v2/identicon/allegador.svg',
                width: 130,
                height: 130,
                titleColor: 'blue',
                colorGrade: 500,
                colorGradeDark: 200,
                tools: ['Nuxt.js', 'Buefy', 'Django REST Framework', 'PostgreSQL']
            },
            {
              title: "Nydcore", 
              url: '/nydcore',
              description: "Sitio web con información de la empresa y muestra de servicios tecnológicos",
              subtitle:'Empresa tecnológica',
              year:'2020',
              logo: '/images/logos/LOGO-1.png',
              width: 180,
              height: 90,
              titleColor: 'gray',
              colorGrade: 700,
              colorGradeDark: 300,
              tools: ['Nuxt.js', 'Bulma.io']
            },
            {
              title: "Xhibidor", 
              url:'/xhibidor',
              description: "Catalogo digital, carta de precios, información de contacto y servicio delivery online",
              subtitle:'Catálogo Online',
              year:'2020',
              logo:'/images/logos/logo-xhibitor-min.png',
              width: 130,
              height: 130,
              titleColor: 'yellow',
              colorGrade: 900,
              colorGradeDark: 600,
              tools: ['Nuxt.js', 'Bulma.io']
            },
            {
                title: "MUCRISIS", 
                url: '/mucrisis',
                description: "Desarrollo de sitio web con tematica de videojuego MMORGP",
                subtitle:'Videojuego MMORPG',
                year:'2019',
                logo:'/images/logos/mucrisis-logo.png',
                width: 130,
                height: 130,
                titleColor: 'blue',
                colorGrade: 500,
                colorGradeDark: 200,
                tools: ['Vue.js', 'Bulma.io', 'Django REST Framework', 'SQLServer 2012']
            },
            {
              title: "Habeatat", 
              url: '/habeatat',
              description: "Sitio web de presentación de Artistas, Eventos y Contenido original.",
              subtitle:'Compañía Discográfica',
              year:'2019',
              logo:'/images/logos/habeatat-logo7-min.png',
              width: 130,
              height: 130,
              titleColor: 'yellow',
              colorGrade: 700,
              colorGradeDark: 300,
              tools: ['Vue.js', 'Bulma.io', 'Django REST Framework', 'PostgreSQL']
            },
            {
              title: "Dr.Difs", 
              url:'https://ndv-drdifs.herokuapp.com',
              description: "Sitio web con información de la Clínica, los servicios que ofrece y la información de contacto.",
              subtitle:'Clínica Estética',
              year:'2018',
              logo:'/images/logos/drdifs-logo-min.png',
              width: 130,
              height: 130,
              titleColor: 'gray',
              colorGrade: 500,
              colorGradeDark: 100,
              tools: ['Django', 'Bootstrap 3', 'PostgreSQL'],
            },
        ]
    },
    timeline: {
        title: 'Mi trayectoria',
        items: [
            {
                id: 8,
                direction: 'Temuco, Chile',
                name: 'LinkosTI',
                icon: 'work',
                title: 'Desarrollador Web Front-end [Senior]',
                description: 'Desarrollo de aplicaciones web las cuales hacen posible centrar las operaciones automatizadas de una organización, poniéndolas a disposición de todos los usuarios a través de un navegador web.',
                link: 'http://linkosti.com/',
                cardColor: 'green',
                logo: '/images/logos/linkosti-logo.jpg',
                year: 2021,
                month: 8,
                time: 'Actualidad',
                category: "Experiencia Laboral",
                show: false
            },
            {
                id: 7,
                direction: 'Caracas, Venezuela',
                name: 'Innotica',
                icon: 'work',
                title: 'Programador Web Full Stack [Mid-Level]',
                description: 'Desarrollo y mantenimiento de las aplicaciones web empresariales. Programación de microservicios.',
                link: 'https://innotica.net/',
                cardColor: 'green',
                logo: '/images/logos/innotica-logo.jpg',
                year: 2020,
                month: 1,
                time: '1 año, 4 meses',
                category: "Experiencia Laboral",
                show: false
            },
            {
                id: 6,
                direction: 'Caracas, Venezuela',
                name: 'Cripto Futuro',
                icon: 'grade',
                title: 'Taller de mineria básico y avanzado',
                description: 'Introducción al mundo de las Criptomonedas y mantenimiento básico de maquinas minadoras.',
                link: 'https://drive.google.com/file/d/0B2X0GdbNhNR0b2tzaXlPTFRnbTZlOUt6T0w0bHdjVk56MExR/view?usp=drive_open',
                cardColor: 'orange',
                logo: '/images/logos/cf-logo.jpg',
                year: 2019,
                month: 8,
                time: '',
                category: "Licencias y Certificaciones",
                show: false
            },            
            {
                id: 5,
                direction: 'Caracas, Venezuela',
                name: 'Compañía Discográfica, Habeatat',
                icon: 'work',
                title: 'Arquitecto de Software [Mid-Level]',
                description: 'Implementar una arquitectura que tenga como objetivo el utilizar nuevas tecnologías para su uso cotidiano dentro del mundo de la música urbana.',
                link: 'https://habeatat.com',
                cardColor: 'green',
                logo: '/images/logos/habeatat-logo.jpg',
                year: 2018,
                month: 12,
                time: '1 año',
                category: "Experiencia Laboral",
                show: false
            },
            {
                id: 4,
                direction: 'Caracas, Venezuela',
                name: 'Vikua',
                icon: 'work',
                title: 'Desarrollador Web [Junior]',
                description: 'Forjador de Código. Implantar nuevas tecnologías de la información como desarrollador para innovar en el mercado mundial y hacer de la ciencia ficción una realidad.',
                link: 'https://vikua.com/',
                cardColor: 'green',
                logo: '/images/logos/vikua-logo.jpg',
                year: 2018,
                month: 4,
                time: '8 meses',
                category: "Experiencia Laboral",
                show: false
            },
            {
                id: 3,
                direction: 'Caracas, Venezuela',
                name: 'Fundación Programa Alimentos Estratégico (FUNDAPROAL)',
                icon: 'work',
                title: 'Analista de Sistemas [Junior]',
                description: 'Implementar sistemas administrativos y aplicaciones web que beneficien a los procedimiento dentro de la Fundación.',
                link: 'http://www.fundaproal.gob.ve/',
                cardColor: 'green',
                logo: '/images/logos/fundaproal-logo.jpeg',
                year: 2016,
                month: 1,
                time: '2 años',
                category: "Experiencia Laboral",
                show: false
            },
            {
                id: 2,
                direction: 'Caracas, Venezuela',
                name: 'SUPERATEC',
                icon: 'favorite',
                title: 'Facilitador en informática básica',
                description: 'Dictar cursos en informática básica, introducción al mundo de las computadoras y herramientas del día a día.',
                link: 'http://superatec.org.ve/',
                cardColor: 'red',
                logo: '/images/logos/superatec-logo.jpg',
                year: 2015,
                month: 4,
                time: '6 meses',
                category: "Voluntariado",
                show: false
            },
            {
                id: 1,
                direction: 'Caracas, Venezuela.',
                icon: 'local_library',
                title: 'Licenciatura, Ciencias de la Computación',
                name: 'Pregrado, Universidad Nueva Esparta (UNE)',
                description: 'El Licenciado en Computación egresado de la UNE maneja hardware y software de actualidad para dar asistencia a las necesidades de empresas nacionales e internacionales, asiste a profesionales de otras disciplinas, crea paquetes especializados que contribuyen con el progreso y sistematización de distintas áreas, está preparado para actuar en equipos expertos y en sistemas de información, para adaptarse a las tendencias contemporáneas.',
                link: 'http://une.edu.ve/',
                cardColor: 'blue',
                logo: '/images/logos/une-logo.jpg',
                year: 2013,
                month: 1,
                time: '5 años',
                category: "Educación",
                show: false
            },

        ]
    },
    apps: {
        "xhibidor": ['carne-y-vino-grill',],
    },
    sendgrid: {
        key: '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'
    },
    reCaptcha: {
        key: 'AIzaSyAejc3oHE3wnhe8G1ah4REXVqMWbb_3c3E'
    },
    error: {
        '404': {
            title: '404',
            subtitle: 'oops! Página no encontrada',
            description: 'La página que busca no existe. Puede que se haya movido o eliminado.'
        }
    }
}

export default state